(() => {
  if (window.__mkoHeaderEnhancementReadyV2) return;
  window.__mkoHeaderEnhancementReadyV2 = true;

  const openClass = 'mko-menu-is-open';

  const drawerIsOpen = (drawer) => {
    if (!drawer) return false;
    return !drawer.hidden && drawer.getAttribute('aria-hidden') !== 'true';
  };

  const resetDrawerScroll = (drawer) => {
    if (!drawer) return;

    const reset = () => {
      const wrapper = drawer.querySelector('.drawer__wrapper');
      const body = drawer.querySelector('.drawer__body');
      const menu = drawer.querySelector('.menu-drawer');

      if (wrapper) wrapper.scrollTop = 0;
      if (body) body.scrollTop = 0;
      if (menu) menu.scrollTop = 0;
    };

    requestAnimationFrame(reset);
    window.setTimeout(reset, 80);
  };

  const syncDrawerState = (drawer) => {
    const isOpen = drawerIsOpen(drawer);
    document.documentElement.classList.toggle(openClass, isOpen);
    if (isOpen) resetDrawerScroll(drawer);
  };

  const enhanceHeader = () => {
    document.querySelectorAll('.js-menu-drawer-trigger').forEach((trigger) => {
      if (!trigger.querySelector('.mko-header-menu-label')) {
        const label = document.createElement('span');
        label.className = 'mko-header-menu-label';
        label.setAttribute('aria-hidden', 'true');
        label.textContent = 'Menu';
        trigger.appendChild(label);
      }

      if (!trigger.dataset.mkoMenuBound) {
        trigger.dataset.mkoMenuBound = 'true';
        trigger.addEventListener('click', () => {
          const drawer = document.getElementById('menuDrawer');
          window.setTimeout(() => syncDrawerState(drawer), 0);
        });
      }
    });

    const drawer = document.getElementById('menuDrawer');
    if (!drawer) return;

    drawer.classList.add('mko-menu-drawer');

    const drawerHeading = drawer.querySelector('.drawer__heading');
    if (drawerHeading) drawerHeading.textContent = 'Esplora MKO';

    if (!drawer.__mkoStateObserver) {
      drawer.__mkoStateObserver = new MutationObserver(() => syncDrawerState(drawer));
      drawer.__mkoStateObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden']
      });

      drawer.addEventListener('click', (event) => {
        if (event.target.closest('.js-menu-drawer-btn-close, .js-menu-drawer-overlay')) {
          window.setTimeout(() => syncDrawerState(drawer), 0);
        }
      });
    }

    syncDrawerState(drawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceHeader, { once: true });
  } else {
    enhanceHeader();
  }

  document.addEventListener('shopify:section:load', enhanceHeader);
})();
